/**
 * Helper para manejar errores de rate limiting (429)
 * Detecta errores 429 y muestra un modal usando el contexto
 */

import { AnalyticsEvents } from '../services/analytics';

let showRateLimitErrorFn: ((message: string) => void) | null = null;

/**
 * Registra la función para mostrar errores de rate limiting
 * Debe ser llamado desde un componente que tenga acceso al contexto
 */
export const registerRateLimitErrorHandler = (handler: (message: string) => void) => {
  showRateLimitErrorFn = handler;
};

/**
 * Maneja un error y muestra modal si es un error 429
 */
export const handleRateLimitError = (error: any): boolean => {
  // Verificar si es un error 429 (Too Many Requests)
  if (error?.status === 429 || error?.statusCode === 429) {
    const errorMessage = error?.message || error?.error || 'Has realizado demasiadas solicitudes. Por favor, espera unos minutos.';
    
    // Obtener endpoint de la URL si está disponible
    let endpoint = 'unknown';
    if (error?.config?.url) {
      try {
        const url = new URL(error.config.url, window.location.origin);
        endpoint = url.pathname;
      } catch (e) {
        endpoint = error.config.url;
      }
    } else if (error?.url) {
      try {
        const url = new URL(error.url, window.location.origin);
        endpoint = url.pathname;
      } catch (e) {
        endpoint = error.url;
      }
    }
    
    // Track rate limit hit
    AnalyticsEvents.rateLimitHit(endpoint);
    
    if (showRateLimitErrorFn) {
      showRateLimitErrorFn(errorMessage);
      return true; // Error manejado
    }
  }
  return false; // No es un error 429 o no hay handler registrado
};

/**
 * Verifica si una respuesta es un error 429
 */
export const isRateLimitError = (response: Response): boolean => {
  return response.status === 429;
};
